import React from 'react'
import { ShieldAlert } from 'lucide-react'

export default function AccessDenied({ title = 'Acesso negado', message = 'Você não tem permissão para acessar esta área.', onGoHome }) {
  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-slate-900/70 border border-slate-800 rounded-2xl shadow-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-xl bg-rose-500/10 border border-rose-500/20 flex items-center justify-center text-rose-300">
            <ShieldAlert size={20} />
          </div>
          <div className="flex flex-col">
            <h1 className="text-xl font-black text-white leading-tight">{title}</h1>
            <p className="text-sm text-slate-400">{message}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={onGoHome}
          className="w-full h-11 rounded-xl bg-slate-800 text-white font-black hover:bg-slate-700 transition"
        >
          Voltar
        </button>
      </div>
    </div>
  )
}

